import { ContentWithRightSidebarProps, SIDEBAR_WIDTH } from './ContentWithRightSidebar.types';

const ContentWithRightSidebar = ({
  content,
  sidebar,
  sidebarWidth = SIDEBAR_WIDTH.DEFAULT,
}: ContentWithRightSidebarProps): React.ReactElement => {
  return (
    <div className="flex flex-row">
      <div className="flex-1 min-h-mainContent">
        <div className="pt-4 px-14">{content}</div>
      </div>
      <div className={`${sidebarWidth} bg-neutral-100 border-l border-neutral-300`}>
        <div className={`fixed h-mainContent overflow-hidden ${sidebarWidth}`}>{sidebar}</div>
      </div>
    </div>
  );
};

export default ContentWithRightSidebar;
